import React, { useState } from "react";
import { Card, CardContent, CardHeader, Button, List, ListItem, ListItemText, Switch, FormControlLabel, Alert } from "@mui/material";
import { useUser } from "./UserProvider";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { NavBar } from "./Navbar";

const plans = [
  {
    name: "Free",
    features: [
      "10 designs/month",
      "Basic templates",
      "Watermark",
      "Email Support",
    ]
  },
  {
    name: "Basic",
    monthlyPrice: "$14.99 / month",
    annualPrice: "$9.99 / month",
    discount: "33% Off",
    features: [
      "100 designs/month",
      "Basic templates",
      "Unlimited Edits",
      "Unlimited Downloads",
      "Custom Branding",
      "Email Support",
    ],
    monthlyUrl: 'https://store.makemybrand.ai/buy/49278c51-9434-46da-88f7-546674748657?enabled=673112',
    annualUrl: 'https://store.makemybrand.ai/buy/0679fe47-3def-42ca-8af2-6973ee83b74a?enabled=673114'
  },
  {
    name: "Premium",
    monthlyPrice: "$24.99 / month",
    annualPrice: "$15.99 / month",
    discount: "36% Off",
    features: ["Everything in Basic Plan", "Premium templates"],
    monthlyUrl: 'https://store.makemybrand.ai/buy/5c6cafdb-5b40-4627-bad7-991e9d9b3b28?enabled=673113',
    annualUrl: 'https://store.makemybrand.ai/buy/2dfd878c-e1e6-448f-9df3-fb944f456e65?enabled=681485'
  },
];

const ChoosePlan = () => {
  const { userInfo } = useUser();
  const { expired } = useParams();
  const [isAnnual, setIsAnnual] = useState(false);

  return (
    <>
    <NavBar />
    <div style={{ padding: "2rem", maxWidth: 1000, margin: "auto" }}>
      {expired && (
        <div style={{ marginBottom: 30, textAlign: "center" }}>
          Please purchase a plan to continue generating designs.
        </div>
      )}
      
      <div style={{ 
            display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center", marginBottom: "1rem"
        }}>
        <FormControlLabel
            control={<Switch checked={isAnnual} onChange={() => setIsAnnual(!isAnnual)} />}
            label="Paid Annually (33% Off)"
        />
      </div>
      
      <div style={{ display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center" }}>
        {plans.map((plan, index) => (
          <Card
            key={index}
            elevation={3}
            style={{
              borderRadius: "12px",
              textAlign: "center",
              flex: "1",
              marginLeft: index === 2 ? -10 : 0,
              marginRight: index === 0 ? -10 : 0,
              zIndex: index === 1 ? 1 : 0
            }}
          >
            <CardHeader
              title={plan.name}
              style={{
                fontSize: "1.5rem",
                fontWeight: "bold",
                backgroundColor: index === 1 ? "purple" : "#f5f5f5",
                color: index === 1 ? "white" : "black",
                padding: "1rem",
              }}
            />
            <CardContent>
              <div style={{ fontSize: "1.25rem", fontWeight: "bold", marginBottom: "0.5rem" }}>
                {isAnnual ? plan.annualPrice : plan.monthlyPrice}
              </div>
              {isAnnual && <div style={{ color: "green", fontWeight: "bold" }}>{plan.discount}</div>}
              <List>
                {plan.features.map((feature, i) => (
                  <ListItem key={i} disableGutters>
                    <ListItemText primary={feature} style={{ textAlign: "center" }} />
                  </ListItem>
                ))}
              </List>
              {index !== 0 && (
              
                  <Button
                    variant={index === 1 ? "contained" : "outlined"}
                    style={{
                      marginTop: "1rem",
                      borderRadius: "20px",
                      padding: "0.5rem 2rem",
                    }}
                    onClick={() => {
                      let url = isAnnual ? plan.annualUrl : plan.monthlyUrl;
                      if (userInfo?.email) url += `?checkout[email]=${userInfo.email}`;
                      window.open(url, '_blank');
                    }}
                  >
                    Subscribe to {plan.name}
                  </Button>
              )}
            </CardContent>
          </Card>
        ))}
      </div>


      {!expired && (
        <div style={{ 
          marginTop: 40, 
          textAlign: "center", 
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}>
          <Alert severity="info" color="primary">
            <div>All carousels are free to generate using our free templates, with a watermark.</div>
            <div>Please purchase a plan to remove watermark and to access premium templates.</div>
          </Alert>
        </div>
      )}
    </div>
    </>
  );
};

export default ChoosePlan;
